import {
  FieldConfig,
  FieldDataTypes,
  NameableInterface,
  nString,
  uString,
} from '@hidat/huijs-common';
import {
  BrandedResource,
  ExtendedBrandingInterface,
} from './branded-resource.interface';
import { SplixerResourceInterface } from './splixer-resource.interface';
import { ResourceConfig } from '@hidat/huijs-resource';
import { BrandedResourceFields } from '@rbl/common';
import {
  splixerFieldConfigs,
  splixerSystemFields,
} from './splixer-fields.const';
import { HashViews } from './hash-views';
import { SplixerResourceTypes } from './splixer-resource-types';

export const BrandedTagConfig: ResourceConfig = new ResourceConfig(SplixerResourceTypes.BrandedTag)
  .addFields(
    [splixerFieldConfigs.intId, splixerFieldConfigs.status],
    true,
    HashViews.player,
  )
  .addFields(BrandedResourceFields, true, HashViews.player)
  .addFields(
    [
      new FieldConfig('code').setRequired(true),
      new FieldConfig('klass').setRequired(true),
      new FieldConfig('priority', FieldDataTypes.INTEGER).setRequired(true),
    ],
    true,
    HashViews.player,
  )
  .addFields(splixerSystemFields)
  .setSorts({
    name: 'name',
    code: 'code',
  })
  .setDefaultSort('name');

export interface BrandedTagInterface
  extends
    SplixerResourceInterface<number>,
    NameableInterface,
    BrandedResource<number> {
  code: uString;
  klass: uString;
  name: uString;
  tagLine: nString;
  description: nString;
  imageUrl: nString;
  branding: ExtendedBrandingInterface | undefined;
  priority: number | undefined;
}
